export const SIZE_BASE = 1.95;

export const rem = (px: number) => {
  const _rem = (px / 1.55) * 0.1;

  return _rem + 'rem';
};
